// extracted by mini-css-extract-plugin
module.exports = {"requirements":"style_requirements__nPFoQ"};